/**
 * 应用入口文件
 * 初始化 Vue 实例、注册全局插件和组件库
 */
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueRouter from "vue-router";
import axios from 'axios'
import initRichText from './utils/initHTMLEditor'
import 'font-awesome/css/font-awesome.min.css'
import './styles/global.css'


Vue.use(initRichText)
// 生产环境跨域设置
Vue.config.productionTip = false;
//生产
Vue.prototype.baseUrl = process.env.NODE_ENV === "production" ? "https://cloudexhibition.chinafastenerinfo.com/api" : "http://192.168.44.66:8005/api";
// Vue.prototype.baseUrl = process.env.NODE_ENV === "production" ? "https://cloudexhibition.chinafastenerinfo.com/api" : "https://cloudexhibition.chinafastenerinfo.com/api";
Vue.use(ElementUI);
Vue.use(VueResource);
Vue.use(VueRouter);



Vue.prototype.$axios = axios


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  // components: { App },
  // template: '<App/>'
}).$mount('#app');

router.afterEach(router => {
    window.scroll(0, 0)
});




// WEBPACK FOOTER //
// ./src/main.js